import {useMutation, useQueryClient} from "@tanstack/react-query";

import {VEHICLE_CHECK_QUERY_KEYS} from "../lib/constants";
import {vehicleChecksService} from "../services";
import type {VehicleCheckCreatePayload} from "../types";

export function useVehicleCheckCreate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: VehicleCheckCreatePayload) =>
      vehicleChecksService.createVehicleCheck(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.list]});
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.infinite]});
    },
  });
}
